import type { IconSvgObject } from './types';

const WiseIcon: IconSvgObject = [
  ["path", { d: "M10.9999 22L19 2H7.00002L9.49994 6.5L4.99994 11H11.9999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default WiseIcon;
